import { serverDateSort } from 'components/Tables/dateSorting';
import React from 'react';
import moment from 'moment';
import CCCTable from '../../../../components/CCCTable/CCCTable';
import {
  QUERY_LIST_DEVICE,
  QUERY_TOTAL_DEVICE,
} from '../../../../queries/DeviceQueries';

interface StationDevicesTabProps {
  corpClientId: number;
}

const StationDevicesTab: React.FC<StationDevicesTabProps> = ({
  corpClientId,
}) => {
  const columns = [
    {
      title: 'Created At',
      ...serverDateSort(true),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date: string) => (date ? moment(date).format('LLL') : '-'),
    },
    {
      title: 'Last Active At',
      ...serverDateSort(),
      dataIndex: 'last_active_at',
      key: 'last_active_at',
      render: (date: string) => (date ? moment(date).format('LLL') : '-'),
    },
  ];

  if (!corpClientId) return null;

  return (
    <CCCTable
      rowKey="device_id"
      query={QUERY_LIST_DEVICE}
      queryKey="listDevice"
      totalQuery={QUERY_TOTAL_DEVICE}
      totalQueryKey="totalDevice"
      columns={columns}
      where={{
        corporate_client_id: { eq: corpClientId },
      }}
    />
  );
};

export default StationDevicesTab;
